import { render, staticRenderFns } from "./LinkWallet.vue?vue&type=template&id=345ac972&"
import script from "./LinkWallet.vue?vue&type=script&lang=ts&"
export * from "./LinkWallet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports